<!-- 安装费用 -->
<template>
  <div style="background: #eee;" class="page-container">
    <van-sticky>
      <van-nav-bar title="安装费用详情" left-text="返回" left-arrow @click-left="goback" />
      <van-grid :column-num="1" v-if="orderList.length > 0">
        <van-grid-item>
          <span>{{ `订单数量: ${orderList.length} | 用线长度：${lineLength} | 增项费用：${addOutlay}` }}</span>
          <span v-for="(item, index) in contTableDataGroupView" :key="index"
            style="margin-right: 15px; font-size: 12px; display: inline-block">
            {{
              item.installerIdStr +
              `(${item.children.length}单): ${item.totalInstallFee}元;`
            }}
            <span v-if="
              contTableDataGroupTotal.length > 1 &&
              index === contTableDataGroupView.length - 1
            " style="color: #1989fa; margin-left: 10px" @click="showAll = !showAll">
              {{ showAll ? "折叠" : "...展开" }}</span>
          </span>
        </van-grid-item>
        <van-grid-item class="vant-grid-item_content">
          <van-search v-model.trim="params.content" style=" width: 100%; padding-block: 2px; padding-top: 10px;"
            placeholder="品牌/车型/客户名/客户电话/主机厂/上游/车架">
          </van-search>
          <van-search v-model.trim="params.installerIdStr" style=" width: 100%;padding-block: 2px ;" placeholder="安装师傅">
          </van-search>
          <van-row type="flex" justify="space-between" align="center" style="width: 100%; padding: 0 12px;">
            <van-col>
              <van-button type="default" style="color: red; border: 0px; padding-left: 0px;height: 34px;"
                @click="downloadExcel()">下载</van-button>
            </van-col>
            <van-col>
              <van-button type="default" style="color: red; border: 0px; padding-right: 0px;height: 34px;"
                @click="search()">查询</van-button>
              <van-button type="default" style="color: red; border: 0px; padding-right: 0px;height: 34px;"
                @click="onClear()">清空</van-button>
            </van-col>
          </van-row>
          <!-- <van-cell-group>
            <van-field v-model="value" label="文本" placeholder="请输入用户名" />
          </van-cell-group> -->
        </van-grid-item>
      </van-grid>
    </van-sticky>

    <MobileTablePro :columns="columns" :data="orderListFiltered" :loading="loading" :has-more="false" @load="onLoad"
      :sticky-header="stickyHeader" :show-tooltip="false" :fit-content="true" @row-click="handleRowClick" @action="handleAction">
    </MobileTablePro>
  </div>
</template>
<script>
import Big from "big.js";
import * as XLSX from "xlsx";
import { Toast } from "vant";
import MobileTablePro from '@/components/MobileTablePro.vue'
import { tableDataGroupAndTotal, tableDataCommonSearch, multipleFuzzyQueries } from "@/views/settlement/columns.js";
const FUZZY_KEYS = ["customerName", "contactInfo", "vin", "brandIdStr", "carModelIdStr", "mainOrderNo", "upstreamOrderNo"]
export default {
  name: "InstallPage",
  components: { MobileTablePro },
  data() {
    return {
      loading: false,
      finished: false,
      orderList: [{}],
      orderListFiltered: [],
      contTableDataGroupTotal: [],
      showAll: false,
      lineLength: 0,
      addOutlay: 0,
      params: {
        installerIdStr: "",
      },
      columns: [
        { key: 'serialNumber', title: '序号', width: '50px', fixed: 'left' },
        { key: 'brandIdStr', title: '品牌', width: '80px' },
        { key: 'carModelIdStr', title: '车型', width: '60px' },
        { key: 'mainOrderNo', title: '主机订单号', width: '120px' },
        { key: 'upstreamOrderNo', title: '上游订单号', width: '120px' },
        { key: 'customerName', title: '客户名称', width: '60px' },
        { key: 'contactInfo', title: '联系方式', width: '100px' },
        { key: 'vin', title: '车架号', width: '60px' },
        { key: 'installerIdStr', title: '安装师傅', width: '60px' },
        { key: 'lineLength', title: '用线长度', width: '60px' },
        { key: 'addOutlay', title: '增项费用', width: '60px' },
        { key: 'installFee', title: '安装费用', width: '60px' },
        { key: 'remarks', title: '备注', width: '60px' },
        { key: 'createTime', title: '创建时间', width: '140px' },
        { key: 'createdByStr', title: '创建人', width: '60px' },
        { key: 'updateTime', title: '修改时间', width: '140px' },
        { key: 'updatedByStr', title: '修改人', width: '60px' },
      ],
      stickyHeader: true,
    };
  },
  computed: {
    contTableDataGroupView() {
      if (this.contTableDataGroupTotal.length <= 1) {
        return this.contTableDataGroupTotal;
      }
      return this.showAll
        ? this.contTableDataGroupTotal
        : this.contTableDataGroupTotal.slice(0, 1);
    },
  },
  methods: {
    handleRowClick() {
      // alert(`点击了第${rowIndex + 1}行，用户：${row.name}`)
    },
    handleAction() {
      // alert(`点击了${action}，第${rowIndex + 1}行，用户：${row.name}`)
    },

    search() {
      if (this.params.installerIdStr || this.params.content) {
        if (this.params.installerIdStr) {
          this.orderListFiltered = tableDataCommonSearch(this.orderList, [{ key: 'installerIdStr', value: this.params.installerIdStr }])

          if (this.params.content) {
            this.orderListFiltered = multipleFuzzyQueries(this.orderListFiltered, this.params.content, FUZZY_KEYS)
          }

        } else if (this.params.content) {
          this.orderListFiltered = multipleFuzzyQueries(this.orderList, this.params.content, FUZZY_KEYS)
        }
      } else {
        this.orderListFiltered = this.orderList;
      }
    },
    onClear() {
      this.params = {
        installerIdStr: ""
      }
      this.orderListFiltered = this.orderList;
    },
    downloadExcel() {
      const list = this.orderListFiltered || [];
      if (!list.length) {
        Toast("暂无数据可下载");
        return;
      }

      const excelData = list.map((item) => {
        const row = {};
        this.columns.forEach((col) => {
          const value = item[col.key];
          row[col.title] = value === null || value === undefined ? "" : value;
        });
        return row;
      });

      const headers = this.columns.map((col) => col.title);
      const ws = XLSX.utils.json_to_sheet(excelData, { header: headers });
      ws["!cols"] = this.columns.map((col) => {
        const width = parseInt(col.width, 10);
        return { wch: Number.isNaN(width) ? 12 : Math.max(Math.round(width / 8), 8) };
      });

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "安装费用");

      const batchName = this.$route.query.settlementBatchName;
      const safeBatchName = batchName
        ? String(batchName).replace(/[\\/:*?"<>|]/g, "_")
        : "";
      const fileName = safeBatchName
        ? `安装费用_${safeBatchName}.xlsx`
        : "安装费用详情.xlsx";

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = new File([blob], fileName, {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const isWeChat = /MicroMessenger/i.test(navigator.userAgent || "");
      // 优先系统分享（可存本地 / 用其他应用打开），不离开微信、不丢登录态
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        navigator
          .share({
            files: [file],
            title: fileName,
          })
          .then(() => {
            Toast.success("请选择保存到手机或用其他应用打开");
          })
          .catch((err) => {
            if (err && err.name === "AbortError") {
              return;
            }
            this.fallbackExcelDownload(blob, file, fileName, isWeChat);
          });
        return;
      }

      this.fallbackExcelDownload(blob, file, fileName, isWeChat);
    },
    fallbackExcelDownload(blob, file, fileName, isWeChat) {
      if (isWeChat) {
        // 微信内 blob 下载会被拦且丢文件；改为上传后走带 token 的真实下载地址
        this.saveExcelViaUpload(file, fileName);
        return;
      }
      this.triggerBlobDownload(blob, fileName);
      Toast.success("下载成功");
    },
    saveExcelViaUpload(file, fileName) {
      const token = localStorage.getItem("token");
      if (!token) {
        Toast.fail("登录已失效，请重新登录");
        return;
      }
      Toast.loading({ message: "正在准备文件...", forbidClick: true, duration: 0 });
      const formData = new FormData();
      formData.append("file", file, fileName);
      this.axios({
        url: "/attachment/upload",
        method: "post",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((res) => {
          if (res.data.code !== 200 || !res.data.data) {
            Toast.clear();
            Toast.fail(res.data.message || "文件准备失败");
            return Promise.reject(new Error("upload failed"));
          }
          return this.axios({
            url: "/attachment/list",
            method: "post",
            data: { ids: String(res.data.data) },
          });
        })
        .then((res) => {
          Toast.clear();
          const attachment = res && res.data && res.data.data && res.data.data[0];
          if (!attachment || !attachment.fileUrl) {
            Toast.fail("获取文件信息失败");
            return;
          }
          // 真实 http 下载地址（带 token）：微信内可下；即便跳系统浏览器也直接下文件，无需再登 H5
          const downloadUrl =
            `/api/attachment/download?fileUrl=${encodeURIComponent(attachment.fileUrl)}` +
            `&fileName=${encodeURIComponent(attachment.fileName || fileName)}` +
            `&token=${encodeURIComponent(token)}`;
          this.triggerHttpDownload(downloadUrl);
          Toast.success("已开始下载，可到手机「文件」或通知栏查看");
        })
        .catch(() => {
          Toast.clear();
          Toast.fail("下载失败，请稍后重试");
        });
    },
    triggerHttpDownload(downloadUrl) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = downloadUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    triggerBlobDownload(blob, fileName) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 2000);
    },
    goback() {
      //返回上一页
      this.$router.go(-1);
    },
    onLoad() {
      this.finished = false;
      this.getPageData();
    },
    getPageData() {
      this.axios({
        url: "/v1/web/settlement-manage/settlement-order/h5/listModuleDetail",
        method: "get",
        params: {
          id: this.$route.query.id,
          module: "pendingSettlementOrderList",
        },
      }).then((res) => {
        this.orderList = res.data.data.pendingSettlementOrderList;
        this.orderList.forEach((item, index) => {
          item.serialNumber = index + 1;
        });


        this.orderListFiltered = this.orderList;
        this.contTableDataGroupTotal = tableDataGroupAndTotal(
          this.orderList,
          "installerIdStr",
          "installFee"
        );

        this.lineLength = this.orderList.reduce((acc, item) => {
          if (item.lineLength !== undefined && item.lineLength !== null) {
            return acc.plus(new Big(item.lineLength || 0));
          }
          return acc;
        }, new Big(0));

        this.addOutlay = this.orderList.reduce((acc, item) => {
          if (item.addOutlay !== undefined && item.addOutlay !== null) {
            return acc.plus(new Big(item.addOutlay || 0));
          }
          return acc;
        }, new Big(0));
        this.loading = false;
        this.finished = true;
      });
    },
  },
};
</script>

<style scoped>
::v-deep .van-grid-item__text {
  font-size: 16px;
}

::v-deep .vant-grid-item_content .van-grid-item__content {
  padding-block: 0px;
}

.page-container {
  height: 100vh;
  /* display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr; */
}
</style>